import { useDependencies } from '@servicetitan/react-ioc';
import { SEARCH_STORE_TOKEN } from '../stores/search.store';

export const useSearchStore = () => {
    const [searchStore] = useDependencies(SEARCH_STORE_TOKEN);
    return searchStore;
};
